import { logUsage } from 'owa-analytics';

const INLINE_IMAGE_V2_LOG_NAME = 'InlineImagePluginV2';

export interface LogValueTypes {
    lifecycle:
        | 'init' // Init the plugin.
        | 'dispose'; // Dispose the plugin
    newImage:
        | 'insertImage' // Insert new inline image from compose
        | 'disableImg' // Image is removed because inline image is totally disabled in this compose session
        | 'noSrc' // Image is removed because there is no src attribute
        | 'invalidSrc' // Image is removed because src is invalid
        | 'downloadExpirableStart' // Start to download expirable image
        | 'uploadFileFromClipboard' // Upload a pasted file, we get the file object from clipboard directly
        | 'uploadFileFromDataUrl' // Upload a pasted file, we get the file object converted from BASE64 data url
        | 'noFileToUpload'; // Failed to create a file object, no file to upload
    finishExpirable:
        | 'uploadFileFromExpirable' // Successfully download expirable image, and start to upload as attachment
        | 'failToDownloadExpirable' // Fail to download expirable image, can't upload as attachment
        | 'noFileToUploadForExpirable' // Expirable image is downloaded, but fail to create File object, can't upload as attachment
        | 'noWrapperForExpirable'; // The wrapper SPAN was removed by user, no way to replace with objectUrl
    showImage:
        | 'showObjectUrl' // Show inline image using object Url
        | 'showAttachment'; // Show inline image using attachment
    saveImage:
        | 'noDataUrl' // No data url found related to this image, it should be an existing attachment inline image (normal case for image from draft)
        | 'hasOriginalSrc' // Although it has data url, it also has 'originalsrc' attribute, so no action needed
        | 'attachmentFound' // Successfully found related attachment, set originalsrc, size, contenttype to the image (normal case for new image)
        | 'fallbackToDataUrl'; // Attachment not found, use BASE64 data url as fallback
}

export type Logger = <Category extends keyof LogValueTypes>(
    category: Category,
    actionType: LogValueTypes[Category]
) => void;

export default function createLogger(editorId: string): Logger {
    return function log<Category extends keyof LogValueTypes>(
        category: Category,
        actionType: LogValueTypes[Category]
    ) {
        logUsage(INLINE_IMAGE_V2_LOG_NAME, {
            category,
            actionType,
            editorId: editorId,
        });
    };
}
